export default {
  mobile: state => state.user.mobile,
  formCachingInfo: state => state.form.formCachingInfo,
  route: state => state.route.route, // 当前的路由信息
  title: state => state.route.title, // 当前的路由信息
  navBar: state => state.route.showNavBar, // 显示nav_bar
  refresh: state => state.route.refresh, // 显示nav_bar
  tabBar: state => state.route.showTabBar // 显示tab_bar
};
